import { topicPartRepository } from "../../../providers/repositories/topicPartRepository";
import { TopicPart } from "../entities/TopicPart";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const getTopicPartByIdUseCase = {
    async exec(id: string | number): Promise<TopicPart | null> {
        try {
            return await topicPartRepository.getOne(id);
        } catch (error) {
            Logger.error("getTopicPartByIdUseCase", error);
            toast.error(t("action.error"));
        }
        return null;
    },
};
